import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-site-overview',
  templateUrl: './site-overview.component.html',
  styleUrls: ['./site-overview.component.css']
,
  standalone: false
})
export class SiteOverviewComponent implements OnInit {

  constructor( private titleService: Title,) {   this.titleService.setTitle("Site Overview");}

  ngOnInit(): void {
    let title = this.titleService.getTitle();
  }


}
